module.exports = __webpack_public_path__ + "img/rain.5fcdec4d.svg";